import { Dispatch } from "redux";
import * as indDocActions from "../features/merchant/doc";
import * as indProfActions from "../features/indinvestor/profSlice";
import * as indBankActions from "../features/indinvestor/bankSliceInd";

export const initializeDocuments = (dispatch: Dispatch, data: any) => {
  dispatch(indDocActions.setProofDoc({ proof: data.proofOfAddress || [] }));
  dispatch(
    indDocActions.setSalaryProofDoc({ salaryProof: data.salaryProof || [] })
  );
  dispatch(indDocActions.setBankDoc({ bank: data.bankStatement || [] }));
};

export const initializeIndustryDetails = (dispatch: Dispatch, data: any) => {
  dispatch(
    indProfActions.setIndustryGroupRedux({ industryGroup: data.industryGroup })
  );
  dispatch(indProfActions.setIndustryRedux({ industry: data.industry }));
  dispatch(
    indProfActions.setIndustryOthersRedux({
      industryOthers: data.industryOthers,
    })
  );
  dispatch(
    indProfActions.setIndustryDropdownValuesRedux({
      industryDropdownValues: data.industryDropdownValues,
    })
  );
};

export const initializePersonalDetails = (dispatch: Dispatch, data: any) => {
  dispatch(indProfActions.setOccupationeRedux({ occupation: data.occupation }));
  dispatch(
    indProfActions.setExperienceRedux({
      experience: data.numberofYears?.toString() || data.experience,
    })
  );
  dispatch(
    indProfActions.setNationalityRedux({ nationality: data.nationality })
  );
  dispatch(indProfActions.setGenderRedux({ gender: data.gender }));
  dispatch(
    indProfActions.setEmploymentStatusRedux({
      employmentStatus: data.employmentStatus,
    })
  );
  dispatch(
    indProfActions.setEmploymentPositionRedux({
      employmentPosition: data.employmentPosition,
    })
  );
  dispatch(
    indProfActions.setdateOfBirthRedux({ dateOfBirth: data.dateOfBirth })
  );
  dispatch(
    indProfActions.setCountryOfBirthRedux({
      countryOfBirth: data.countryOfBirth,
    })
  );
  dispatch(indProfActions.setIsPepRedux({ isPep: data.isPep }));
  dispatch(
    indProfActions.setEmployerNameRedux({ employerName: data.employerName })
  );
  dispatch(
    indProfActions.setReferralSourceRedux({
      referralSource: data.referralSource,
    })
  );
  dispatch(
    indProfActions.setOtherReferralRedux({ otherReferral: data.otherReferral })
  );
};

export const initializeAddressDetails = (dispatch: Dispatch, data: any) => {
  dispatch(
    indProfActions.setCountryOfResidenceRedux({
      countryOfResidence: data.countryOfResidence,
    })
  );
  dispatch(
    indProfActions.setAddressRedux({ address: data.legalEntityAddress })
  );
  dispatch(
    indProfActions.setPostalCodeRedux({
      postalCode: data.postalCode?.toString(),
    })
  );
  dispatch(indProfActions.setPhoneRedux({ phoneNumber: data.phoneNumber }));
  dispatch(
    indProfActions.setInvestmentAmountRedux({
      investmentAmount: data.investmentAmount || 0,
    })
  );
};

export const initializeBankDetails = (dispatch: Dispatch, data: any) => {
  dispatch(indBankActions.setBankNameRedux({ bankName: data.bankName }));
  dispatch(
    indBankActions.setAccountTypeRedux({ accountType: data.accountType })
  );
  dispatch(
    indBankActions.setAccountNoRedux({ accountNumber: data.accountNumber })
  );
  dispatch(
    indBankActions.setAccountHolderNameRedux({
      accountHolderName: data.accountHolderName,
    })
  );
  dispatch(indBankActions.setSwiftCodeReduct({ swiftCode: data.swiftCode }));
};
